import React from "react";
import { Button, Modal } from "react-bootstrap";
import locale from "locale";

import "./style.scss";

const BannedUsersModal = ({
    users = [],
    isModalVisible,
    onHide,
    onDeleteClientBan,
}) => {
    return (
        <Modal
            show={isModalVisible}
            bsSize="large"
            className="banned-users-modal"
            onHide={onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {locale('client.ban.modal.title')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!!users.length
                    ? <ul className="banned-users-modal-list">
                        {users.map((user) => (
                            <li
                                key={user.id}
                                className="banned-users-modal-item-list"
                            >
                                {user.nickname}
                                <Button onClick={() => onDeleteClientBan(user)}>
                                    {locale('client.unban.button')}
                                </Button>
                            </li>
                        ))}
                    </ul>
                    : <p>{locale('client.ban.modal.emptyList')}</p>
                }
            </Modal.Body>
        </Modal>
    );
};

export default BannedUsersModal;
